/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M6.66667 1.63281V4.96615M13.3333 1.63281V4.96615M2.5 8.29948H17.5M4.16667 3.29948H15.8333C16.7538 3.29948 17.5 4.04567 17.5 4.96615V16.6328C17.5 17.5533 16.7538 18.2995 15.8333 18.2995H4.16667C3.24619 18.2995 2.5 17.5533 2.5 16.6328V4.96615C2.5 4.04567 3.24619 3.29948 4.16667 3.29948Z" stroke="#262626" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default SvgComponent;
